import { render, staticRenderFns } from "./TingList.vue?vue&type=template&id=900fa3dc"
import script from "./TingList.vue?vue&type=script&lang=js"
export * from "./TingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports